import { render, staticRenderFns } from "./BuildHome.vue?vue&type=template&id=4b8ec50e&scoped=true"
import script from "./BuildHome.vue?vue&type=script&lang=js"
export * from "./BuildHome.vue?vue&type=script&lang=js"
import style0 from "./BuildHome.vue?vue&type=style&index=0&id=4b8ec50e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8ec50e",
  null
  
)

export default component.exports